<div class="modal-header border-0">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-4 mt-3"
		>Détail de la tournée</span
	>
	<button
		type="button"
		class="btn-close custom-button-close border border-white rounded-circle bg-white fs-4"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>
<div class="modal-body">
	<div class="row">
		<div class="">
			<div class="row">
				<div class="row mt-4 px-5">
					<span class="theme-main-color fs-4 col">Informations</span>
					<!-- <a [routerLink]="['/gestion/formations',mission.formation.idFormation]" [queryParams]="{ redirected: true }" class="btn col-4 text-white theme-main-background-color" (click)="bsModalRef.hide()"><i class="bi bi-pencil-fill px-1"></i>Modifier la formation</a> -->
				</div>
			</div>

			<div class="row my-5 px-5">
				<div class="col-4">
					<span for="date" class="theme-main-color fw-bold form-label row my-2"
						>Date</span
					>
					<span class="row my-2" id="date">{{
						route?.date | date: 'dd/MM/YYYY'
					}}</span>
				</div>
			</div>
			<div class="row my-5 px-5">
				<div class="col-4">
					<span
						for="centre"
						class="theme-main-color fw-bold form-label row my-2"
						>Centre
					</span>
					<span class="row" id="centre">{{
						route?.employee.serviceCenter.name
					}}</span>
				</div>
				<!-- <div class="col-4">
					<span for="lieu" class="theme-main-color fw-bold form-label row my-2"
						>Lieu</span
					>
					<span class="row my-2" id="lieu">
						{{ mission.missionRequest.missionPlace.nameDisplay }}</span
					>
				</div>
				<div class="col-4">
					<span
						for="typeFormation"
						class="theme-main-color fw-bold form-label row my-2"
						>Type de mission
					</span>
					<span class="row my-2" id="typeFormation">{{
						mission.missionRequest.missionType?.type
					}}</span>
				</div> -->
			</div>

			<div class="row my-5 px-5">
				<div class="col-6">
					<span
						for="heureDebut"
						class="theme-main-color fw-bold form-label row my-2"
						>Heure de début de tournée</span
					>
					<span class="row my-2" id="heureDebut">{{
						route?.missions[0].plannedStart | minutesToTime
					}}</span>
				</div>
				<div class="col-6">
					<span
						for="heureFin"
						class="theme-main-color fw-bold form-label row my-2"
						>Heure de fin de tournée</span
					>
					<span class="row my-2" id="heureFin">{{
						route?.missions[route?.missions.length - 1].plannedEnd
							| minutesToTime
					}}</span>
				</div>
			</div>
			<!-- <div class="row my-5 px-5">
				<div class="col-6">
					<span
						for="heureDebut2"
						class="theme-main-color fw-bold form-label row my-2"
						>Heure de début de formation</span
					>
					<span class="row my-2" id="heureDebut2">{{
						mission.missionRequest.readyTime | minutesToTime
					}}</span>
				</div>
				<div class="col-6">
					<span
						for="heureFin2"
						class="theme-main-color fw-bold form-label row my-2"
						>Heure de fin de formation</span
					>
					<span class="row my-2" id="heureFin2">{{
						mission.missionRequest.dueTime | minutesToTime
					}}</span>
				</div>
			</div> -->
			<div class="row my-5 px-5">
				<div class="col-4">
					<span
						for="tempsMission"
						class="theme-main-color fw-bold form-label row my-2"
						>Durée de la tournée</span
					>
					<span class="row my-2" id="tempsMission">{{
						route?.missions[route?.missions.length - 1].plannedEnd -
							route?.missions[0].plannedStart | minutesToTime
					}}</span>
				</div>
				<div class="col-4">
					<span
						for="distanceParcourue"
						class="theme-main-color fw-bold form-label row my-2"
						>Distance parcourue</span
					>
					<span class="row my-2" id="distanceParcourue"
						>{{ route?.plannedDistance / 1000 | number: '1.2-2' }} km</span
					>
				</div>
				<!-- <div class="col-4">
					<span
						for="planner"
						class="theme-main-color fw-bold form-label row my-2"
						>Affectateur</span
					>
					<span class="row my-2" id="planner"
						>{{ mission.planner.firstName }}
						{{ mission.planner.lastName }}</span
					>
				</div> -->
			</div>
		</div>
	</div>
</div>
